import { makeStyles } from '@mui/styles';
import { BREAKPOINTS } from '@styles/breakpoints';
import { COLORS } from '@styles/colors';
import { Z_INDEXES } from '@styles/zIndexes';

export const useStyles = makeStyles({
  root: {
    height: '100%',
  },
  table: {
    width: '100%',
    position: 'relative',
  },
  tableHeaderRow: {
    background: COLORS.HIGHLIGHTS.NEUTRAL,
    color: COLORS.TEXT.SECONDARY,
    position: 'sticky',
    zIndex: Z_INDEXES.HEADER,
    top: 0,
    height: 48,
    fontWeight: '400',
    fontSize: '14px',

    [BREAKPOINTS.DESKTOP13]: {
      height: 32,
      fontSize: 12,

      '& p': {
        margin: 0,
      },
    },

    [BREAKPOINTS.MOBILE]: {
      display: 'none',
    },
  },
  tableDataRow: {
    height: 76,
    [BREAKPOINTS.MOBILE]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, auto)',
      gridTemplateRows: 'repeat(2, auto))',
      marginBottom: 4,
      paddingBottom: 12,
    },
  },
  textSkeleton: {
    width: '80%',
    height: '50%',
    marginLeft: '5%',
  },
  sortHolder: {
    display: 'none',

    [BREAKPOINTS.MOBILE]: {
      width: '100%',
      display: 'flex',
      paddingLeft: 16,
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  },
  loaderHolder: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backToTopButton: {
    zIndex: 1,
    background: COLORS.BRAND.PRIMARY,
    borderRadius: '100%',
    width: 50,
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 25,
    right: 25,
    cursor: 'pointer',

    '& svg': {
      fill: COLORS.WHITE,
    },
  },
});
